import { useLang } from "../i18n/LanguageContext";

export default function LanguageToggle({ className = "" }) {
  const { lang, setLang } = useLang();

  return (
    <div
      data-testid="language-toggle"
      className={`inline-flex items-center border border-gold/30 rounded-sm overflow-hidden text-[11px] font-semibold uppercase tracking-[0.1em] ${className}`}
    >
      {["es", "en"].map((code) => (
        <button
          key={code}
          data-testid={`toggle-lang-${code}`}
          onClick={() => setLang(code)}
          className={`px-3 py-1.5 transition-colors duration-300 ${
            lang === code
              ? "bg-gold text-deepblack"
              : "text-offwhite/70 hover:text-gold"
          }`}
        >
          {code.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
